exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.styleGeneral:hover {\n  text-decoration: underline;\n  -webkit-text-decoration-color: #51a45c;\n          text-decoration-color: #51a45c;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de584a40","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/SettingsList/RequestToPaySettings.vue
// module id = 1656
// module chunks = 2